// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Agent avatars anchored at a connection's label point. The positioning
   transform is inline (it carries labelX/labelY, which only the edge knows);
   everything static lives here. The chips themselves are the shared
   AgentAvatarBadge. */
.CVoaauS_gkrm09fFI6Xj {
  position: absolute;
  /* Sized to its chips, never wider. The parent
     .react-flow__edgelabel-renderer is pointer-events:none, so this element is
     the only thing on the label layer that can intercept a pointer - and every
     pixel it covers is a pixel of edge the user can no longer grab. */
  width: max-content;
  display: flex;
  gap: 6px;
  pointer-events: auto;
  z-index: 5;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/EdgeAgentBadges.module.css"],"names":[],"mappings":"AAAA;;;sBAGsB;AACtB;EACE,kBAAkB;EAClB;;;sEAGoE;EACpE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ","sourcesContent":["/* Agent avatars anchored at a connection's label point. The positioning\n   transform is inline (it carries labelX/labelY, which only the edge knows);\n   everything static lives here. The chips themselves are the shared\n   AgentAvatarBadge. */\n.badges {\n  position: absolute;\n  /* Sized to its chips, never wider. The parent\n     .react-flow__edgelabel-renderer is pointer-events:none, so this element is\n     the only thing on the label layer that can intercept a pointer - and every\n     pixel it covers is a pixel of edge the user can no longer grab. */\n  width: max-content;\n  display: flex;\n  gap: 6px;\n  pointer-events: auto;\n  z-index: 5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badges": `CVoaauS_gkrm09fFI6Xj`
};
export default ___CSS_LOADER_EXPORT___;
